/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  TextField,
} from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IosSwitchMain from "../../components/iosSwitchMain";
import MainContainer from "../../layout/MainContainer";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
type OfferTableProps = {
  actionType?: "active" | "scheduled" | "expired" | "quick";
};

const Userlist = ({ actionType = "quick" }: OfferTableProps) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };
  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const rows = [
    {
      id: 1,
      Name: "Abdul Kean",
      Email: "abdul@sample.com",
      MembershipType: "Single",
      BookingDateTime: "18 - June - 2025 | 6:00PM",
      Price: "500",
      SelectAll: "",
    },
    {
      id: 2,
      Name: "Abdul Kean",
      Email: "abdul@sample.com",
      MembershipType: "Guest",
      BookingDateTime: "18 - June - 2025 | 6:00PM",
      Price: "500",
      SelectAll: "",
    },
    {
      id: 3,
      Name: "Abdul Kean",
      Email: "abdul@sample.com",
      MembershipType: "Single",
      BookingDateTime: "18 - June - 2025 | 6:00PM",
      Price: "500",
      SelectAll: "",
    },
    {
      id: 4,
      Name: "Abdul Kean",
      Email: "abdul@sample.com",
      MembershipType: "Guest",
      BookingDateTime: "18 - June - 2025 | 6:00PM",
      Price: "500",
      SelectAll: "",
    },
    {
      id: 5,
      Name: "Abdul Kean",
      Email: "abdul@sample.com",
      MembershipType: "Duo",
      BookingDateTime: "18 - June - 2025 | 6:00PM",
      Price: "500",
      SelectAll: "",
    },
    {
      id: 6,
      Name: "Abdul Kean",
      Email: "abdul@sample.com",
      MembershipType: "Single",
      BookingDateTime: "18 - June - 2025 | 6:00PM",
      Price: "500",
      SelectAll: "",
    },
  ];

  const toggleExpand = (id: number) => {
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };

  const allRowIds = rows.map((row) => row.id);
  const isAllSelected = selectedRows.length === rows.length;

  const handleCheckboxChange = (id: number) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((rowId) => rowId !== id)
        : [...prevSelected, id]
    );
  };

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setSelectedRows(allRowIds);
    } else {
      setSelectedRows([]);
    }
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      field: "Name",
      headerName: "Name",
      flex: 1,
      minWidth: 140,
      renderCell: () => {
        return (
          <div
            className="user_block click_action"
            onClick={() => navigate("/manage-customers/detail")}
          >
            <figure>
              <img src="/static/images/user_placeholder.png" alt="" />
            </figure>
            <p>
              <b>Madelyn Dias</b>
            </p>
          </div>
        );
      },
    },
    {
      field: "Email",
      headerName: "Email",
      flex: 1,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "MembershipType",
      headerName: "Membership Type",
      flex: 1,
      minWidth: 95,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "BookingDateTime",
      headerName: "Booking Date & Time",
      flex: 1,
      minWidth: 95,
    },
    {
      field: "Price",
      headerName: "Price",
      flex: 1,
      minWidth: 95,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        if (actionType === "active") {
          return (
            <div className="table_actions v2">
              <IconButton className="toggle_btn">
                <IosSwitchMain />
              </IconButton>
              <IconButton className="edit_icon">
                <img src="/static/images/edit_icon.svg" alt="icon" />
              </IconButton>
            </div>
          );
        } else if (actionType === "scheduled") {
          return (
            <div className="table_actions v2">
              <IconButton className="edit_icon">
                <img src="/static/images/calendar_icon.svg" alt="icon" />
              </IconButton>
              <IconButton className="edit_icon">
                <img src="/static/images/edit_icon.svg" alt="icon" />
              </IconButton>
            </div>
          );
        } else if (actionType === "expired") {
          return (
            <div className="table_actions v2">
              <IconButton className="edit_icon">
                <img src="/static/images/copy_icon.svg" alt="icon" />
              </IconButton>
            </div>
          );
        } else if (actionType === "quick") {
          return (
            <div className="table_actions v2">
              <a className="quick_link" href="">
                500
              </a>
            </div>
          );
        }
        return null;
      },
    },
    {
      field: "SelectAll",
      headerName: "Select",
      flex: 1,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
      renderHeader: () => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Checkbox checked={isAllSelected} onChange={handleSelectAllChange} />
          <span style={{ fontWeight: 600 }}>Select All</span>
        </div>
      ),
      renderCell: (params) => {
        return (
          <Checkbox
            checked={selectedRows.includes(params.row.id)}
            onChange={() => handleCheckboxChange(params.row.id)}
          />
        );
      },
    },
  ];

  let hidden = ["fullName"];

  return (
    <MainContainer>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1 className="back_arrow">
            <IconButton onClick={goBack}>
              <ArrowBackIcon />
            </IconButton>{" "}
            User listing
          </h1>
        </div>

        <div className="right_s">
          <Button className="btn btn_primary">Refund Amount</Button>
        </div>
      </div>

      <div className="sorting_table cards table_cards">
        <div className="table_container">
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}
          >
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Membership Type</th>
                <th>Booking Date & Time</th>
                <th>Price</th>
                <th style={{ textAlign: "center" }}>
                  {" "}
                  <div className="select_all">
                    {" "}
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isAllSelected}
                            indeterminate={
                              selectedRows.length > 0 && !isAllSelected
                            }
                            onChange={handleSelectAllChange}
                          />
                        }
                        label="Select All"
                      />
                    </FormGroup>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <React.Fragment key={row.id}>
                  <tr>
                    <td>
                      <div className="user_block click_action">
                        <figure>
                          <img
                            src="/static/images/user_placeholder.png"
                            alt=""
                          />
                        </figure>
                        <p>
                          <b>{row.Name}</b>
                        </p>
                      </div>
                    </td>
                    <td>{row.Email}</td>
                    <td>{row.MembershipType}</td>
                    <td>{row.BookingDateTime}</td>
                    <td>
                      {" "}
                      <div className="control_group enter_amount">
                        <TextField
                          type="number"
                          placeholder="500"
                          hiddenLabel
                          fullWidth
                        ></TextField>
                      </div>
                    </td>

                    <td style={{ textAlign: "center" }}>
                      <div className="table_actions v2">
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedRows.includes(row.id)}
                                onChange={() => handleCheckboxChange(row.id)}
                              />
                            }
                            label=""
                          />
                        </FormGroup>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </MainContainer>
  );
};

export default Userlist;
